import React, { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from "react";
import { PlanWithDiscount } from "pages/Pricing";
import { EBrand } from "pages/Pricing/service/efi.service";
import { IOptionsSelect } from "components/Inputs/interfaces/options.interface";
import { CreateSupplierResponse } from "pages/Pricing/service/landingPage.service";

export enum EPaymentMethod {
  CREDIT_CARD = "CREDIT_CARD",
  PIX = "PIX",
  BOLETO = "BOLETO",
}

interface IPixAndTicket{
  identification: string,
  installmentsNumber: number
}
interface LandingPageContextType {
  plansContext: PlanWithDiscount[];
   setPlansContext: Dispatch<SetStateAction<PlanWithDiscount[]>>
  selectedPlanContext: PlanWithDiscount | null;
  setSelectedPlanContext: Dispatch<SetStateAction<PlanWithDiscount | null>>;
  creditCardContext: ICreditCard
  setCreditCardContext: Dispatch<SetStateAction<ICreditCard>>
  supplierDataContext: CreateSupplierResponse | null;
  pixAndTicketContext: IPixAndTicket;
  setPixAndTicketContext: Dispatch<SetStateAction<IPixAndTicket>>
  setSupplierDataContext: Dispatch<SetStateAction<CreateSupplierResponse | null>>
  paymentMethodContext: EPaymentMethod;
  setPaymentMethodContext: Dispatch<SetStateAction<EPaymentMethod>>
  installmentsContext: IOptionsSelect[];
  setInstallmentsContext: Dispatch<SetStateAction<IOptionsSelect[]>>
  pixCopyAndPasteContext: string | null;
  setPixCopyAndPasteContext: Dispatch<SetStateAction<string | null>>
  timeLeftContext: number;
  setTimeLeftContext: Dispatch<SetStateAction<number>>
  currentStepContext: number;
  setCurrentStepContext: Dispatch<SetStateAction<number>>
  ticketPDF: string | null;
  setTicketPDF: Dispatch<SetStateAction<string | null>>
  quantityOnDemandContext: number,
  setQuantityOnDemandContext: Dispatch<SetStateAction<number>>
  isManualPaymentContext: boolean;
  setIsManualPaymentContext: Dispatch<SetStateAction<boolean>>
}

interface LandingPageProviderProps {
  children: ReactNode;
}

export interface ICreditCard {
  brand: EBrand | null,
  number: string,
  cvv: string,
  expirationMonth: string,
  expirationYear: string,
  holderName: string,
  holderDocument: string,
  reuse: boolean,
}


const LandingPageContext = createContext<LandingPageContextType | undefined>(undefined);

const initialValuesCreditCard = {
  brand: null,
  number: "",
  cvv: "",
  expiration: "",
  holderName: "",
  holderDocument: "",
  reuse: true,
  installmentsNumber: ""
};

const initialValuesPixAndTicket = {
  identification: "",
  installmentsNumber: ""
};

export const LandingPageProvider: React.FC<LandingPageProviderProps> = ({ children }) => {
  const [plansContext, setPlansContext] = useState<PlanWithDiscount[]>([]);
  const [selectedPlanContext, setSelectedPlanContext] = useState<PlanWithDiscount | null>(null);
  const [quantityOnDemandContext, setQuantityOnDemandContext] = useState<number>(1);
  const [creditCardContext, setCreditCardContext] = useState<any>(initialValuesCreditCard);
  const [pixAndTicketContext, setPixAndTicketContext] = useState<any>(initialValuesPixAndTicket);
  const [supplierDataContext, setSupplierDataContext] = useState<CreateSupplierResponse | null>(null);
  const [paymentMethodContext, setPaymentMethodContext] = useState<EPaymentMethod>(EPaymentMethod.CREDIT_CARD);
  const [installmentsContext, setInstallmentsContext] =  useState<IOptionsSelect[]>([]);
  const [pixCopyAndPasteContext, setPixCopyAndPasteContext] =  useState<string | null>(null);
  const [timeLeftContext, setTimeLeftContext] = useState<number>(0);
  const [currentStepContext, setCurrentStepContext] = useState<number>(1);
  const [ticketPDF, setTicketPDF] = useState<string | null>(null);
  const [isManualPaymentContext, setIsManualPaymentContext] = useState<boolean>(false);


  return (
    <LandingPageContext.Provider value={{
      plansContext, setPlansContext,
      selectedPlanContext, setSelectedPlanContext,
      creditCardContext, setCreditCardContext,
      supplierDataContext, setSupplierDataContext,
      paymentMethodContext, setPaymentMethodContext,
      installmentsContext, setInstallmentsContext,
      pixAndTicketContext, setPixAndTicketContext,
      pixCopyAndPasteContext, setPixCopyAndPasteContext,
      timeLeftContext, setTimeLeftContext,
      currentStepContext, setCurrentStepContext,
      ticketPDF, setTicketPDF,
      quantityOnDemandContext, setQuantityOnDemandContext,
      isManualPaymentContext, setIsManualPaymentContext,
    }}>
      {children}
    </LandingPageContext.Provider>
  );
};


export const useLandingPageContext = (): LandingPageContextType => {
  const context = useContext(LandingPageContext);
  if (!context) {
    throw new Error("useLandingPageContext deve ser usado dentro de um LandingPageProvider");
  }
  return context;
};
